export default __webpack_public_path__ + "static/media/mesoterapia_2.1b8eab7a.jpg";